export default __webpack_public_path__ + "static/media/add_user_to_org.5bf52a52.svg";